import { useState, useEffect } from 'react';
import { useAnimatedNavigate } from '../hooks/useAnimatedNavigate';
import { ConnectorList } from '../components/ConnectorList';
import { SystemHealth } from '../components/settings/SystemHealth';
import { UserManagement } from '../components/settings/UserManagement';
import { SetupProgress } from '../components/settings/SetupProgress';
import { IdpConfig } from '../components/settings/IdpConfig';
import { AuditLog } from '../components/settings/AuditLog';
import { useAuth } from '../hooks/useAuth';

const tabs = [
  { id: 'health', label: 'System Health' },
  { id: 'connectors', label: 'Connectors' },
  { id: 'users', label: 'Access Control' },
  { id: 'idp', label: 'Identity Provider' },
  { id: 'audit', label: 'Audit Log' },
] as const;

type TabId = (typeof tabs)[number]['id'];

export function SettingsPage() {
  const navigate = useAnimatedNavigate();
  const { logout } = useAuth();
  const [activeTab, setActiveTab] = useState<TabId>('health');

  // Auto-switch to connectors tab when returning from Microsoft provisioning callback
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('msProvisioning') || params.get('provisioningId')) {
      setActiveTab('connectors');
    }
  }, []);

  return (
    <div className="settings-layout">
      <nav className="settings-sidebar">
        <div className="settings-sidebar-header">
          <button className="settings-sidebar-back" onClick={() => navigate('/')} title="Back to chat">
            &larr;
          </button>
          <span className="settings-sidebar-title">Settings</span>
        </div>
        <div className="settings-nav">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`settings-nav-item ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="settings-nav-footer">
          <button
            className="settings-nav-item settings-logout"
            onClick={() => { void logout(); }}
          >
            Log out
          </button>
        </div>
      </nav>
      <main className="settings-content">
        <SetupProgress />
        {activeTab === 'health' && <SystemHealth />}
        {activeTab === 'connectors' && <ConnectorList />}
        {activeTab === 'users' && <UserManagement />}
        {activeTab === 'idp' && <IdpConfig />}
        {activeTab === 'audit' && <AuditLog />}
      </main>
    </div>
  );
}
